import React from 'react';
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';
import Modal from "../Modal.jsx";
import videosData from "./videos.json"
import { UserInteractionContext } from "../../../../shared/contexts/UserInteractionContext.jsx";

import './VideosModal.scss';

export default class VideosModal extends Modal {
  constructor(props) {
    super(props);

    this.videoRef = React.createRef();
    this.hasPlayedOnce = false;
  }

  state = {
    showControls: false
  };

  componentDidUpdate() {
    const { userHasInteracted } = this.context;

    if (this.props.isOpen && this.videoRef.current) {
      if (userHasInteracted && !this.hasPlayedOnce) {
        this.videoRef.current.muted = false;

        this.videoRef.current.play().catch(err => {
          console.warn("Autoplay bloqué par le navigateur :", err);
        });

        this.hasPlayedOnce = true;
      }
    }
  }

  handleMouseEnter = () => {
    this.setState({ showControls: true });
  };

  handleMouseLeave = () => {
    this.setState({ showControls: false });
  };

  goToTimecode = (seconds) => {
    if (this.videoRef.current) {
      this.videoRef.current.currentTime = seconds;
      this.videoRef.current.play();
    }
  };
    
  render() {
    const currentVideo = videosData?.[this.props?.freelance?.situation] || videosData?.[1];

    if (!this.props.freelance || !currentVideo?.videoPath) {
      return null;
    }

    return (
      <BootstrapModal isOpen={this.props.isOpen} className="videos-modal modal-lg">
        <ModalHeader>
          Préparez votre entretien : découvrez Twineeds
        </ModalHeader>

        <ModalBody>
          <p className="important-msg">
            <strong>Indispensable avant l’entretien&nbsp;: notre échange ne reviendra pas sur ces points et portera uniquement sur votre projet.</strong>
          </p>

          <video
            ref={this.videoRef}
            controls={this.state.showControls}
            disablePictureInPicture
            controlsList="nodownload"
            poster={currentVideo?.posterPath}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
          >
            <source src={currentVideo?.videoPath} type={currentVideo?.videoType} />
          </video>

          <ul className="videos-modal-questions">
            {currentVideo?.questions?.map((question, idx) => (
              <li key={idx}>
                <button className="btn btn-light" onClick={() => this.goToTimecode(question.timecode)}>
                  <span dangerouslySetInnerHTML={{__html: question.category}} />
                  <p dangerouslySetInnerHTML={{__html: question.label}} />
                </button>
              </li>
            ))}
          </ul>

          <div className="text-center">
            <button onClick={this.props.closeModal} className="btn btn-primary">
              Étape suivante
            </button>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

VideosModal.contextType = UserInteractionContext;
